import React from 'react';
import Navbar from '../components/Navbar';

const About = () => {
  return (
    <div className="min-h-screen bg-secondary">
      <Navbar />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-lg shadow-sm overflow-hidden">
          <div className="relative h-64 sm:h-80">
            <img 
              src="https://images.unsplash.com/photo-1500937386664-56d1dfef3854?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80" 
              alt="Farm landscape" 
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-primary bg-opacity-40 flex items-center justify-center">
              <h1 className="text-4xl font-serif font-bold text-white">Our Story</h1>
            </div>
          </div>
          <div className="p-8 sm:p-12">
            <h2 className="text-2xl font-serif font-bold text-primary mb-4">Our Sourcing Philosophy</h2>
            <p className="text-gray-600 font-sans mb-6 leading-relaxed">
              Mohkagz-Fresh Produce was born from a simple desire: to provide the finest produce available. We source high-grade local fruits and vegetables from the fertile farmlands of Northern Nigeria. Additionally, we bring the world to your table by importing premium F1 fruits and vegetables from the Netherlands, South Africa, and other global hubs, ensuring you have access to the best quality produce year-round.
            </p>
            <h2 className="text-2xl font-serif font-bold text-primary mb-4">Our Promise</h2>
            <p className="text-gray-600 font-sans leading-relaxed">
              We believe in quality without compromise. From the sun-ripened tomatoes of Kura to the finest imported exotic fruits, our logistics network is optimized to deliver produce from the farm to your doorstep in record time, preserving the nutrients and taste that nature intended.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;